import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import style from "./style.css";

export default class CheckboxButton extends Component {
  render() {
    const { rootClassname, isDisabled, onChange, label, value, checked, name } = this.props;
    const finalRootClass = classnames(style.root, rootClassname);
    return (
      <div className={finalRootClass}>
        <input type="checkbox" name={name} onChange={onChange} disabled={isDisabled} value={value} checked={checked} />
        <label>{label}</label>
      </div>
    );
  }
}

CheckboxButton.propTypes = {
  label: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  checked: PropTypes.bool,
  rootClassname: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/CheckboxButton/index.js